module.exports = __webpack_public_path__ + "media/slider/Banner-2-7c937fb2.jpg";